export const locationPath = {
  BLOG_ADD: "/blog-add",
  BLOG_EDIT: "/blog-edit/:id",
  BLOG_TRANSLATION_ADD: "/add-blog-detail/:id",
  BLOG_TRANSLATION_EDIT: "/edit-blog-detail/:id/:anId",
  BLOG_LIST: "/blog-list",
  ROLE_ADD: "/role-add",
  ROLE_EDIT: "/role-edit/:id",
  ROLE_LIST: "/role-list",
  USER_ADD: "/user-add",
  USER_EDIT: "/user-edit/:id",
  USER_LIST: "/user-list",
  CLIENT_ADD: "/client-add",
  CLIENT_EDIT: "/client-edit/:id",
  CLIENT_LIST: "/client-list",
  TEAM_ADD: "/team-add",
  TEAM_EDIT: "/team-edit/:id",
  TEAM_LIST: "/team-list",
  TESTIMONIALS_ADD: "/testimonials-add",
  TESTIMONIALS_EDIT: "/testimonials-edit/:id",
  TESTIMONIALS_LIST: "/testimonials-list",
  QA_ADD: "/qa-add",
  QA_EDIT: "/qa-edit/:id",
  QA_LIST: "/qa-list",
  QA_SORTING: "/qa-sorting",
  DOCUMENT_ADD: "/document-add",
  DOCUMENT_EDIT: "/document-edit/:id",
  DOCUMENT_LIST: "/document-list",
  DASHBOARD: "/dashboard",
  SEO_LIST: "/seo/pages/list",
  SEO_FORM: "/seo/pages/form/:id",
  CONTACT_LIST: "/contact-form-list",
  CASE_STUDY_ADD: "/case-study-add",
  CASE_STUDY_EDIT: "/case-study-edit/:id",
  CASE_STUDY_LIST: "/case-study-list",
  RESOURCES_ADD: "/resources-add",
  RESOURCES_EDIT: "/resources-edit/:id",
  RESOURCES_LIST: "/resources-list",
  PRODUCT_ADD: "/product-add",
  PRODUCT_EDIT: "/product-edit/:id",
  PRODUCT_LIST: "/product-list",
  PRODUCT_CHECK: "/products-check",
  PRODUCT_SYNC: "/product-sync",
  PRODUCT_MARGIN: "/product-margin",
  PRODUCT_CATEGORY_SALE: "/product-category-sale",
  NEWSLETTER_LIST: "/newsletter-list",
  SLIDER_ADD: "/slider-add",
  SLIDER_EDIT: "/slider-edit/:id",
  SLIDER_LIST: "/slider-list",
  BANNER_ADD: "/banner-add",
  BANNER_EDIT: "/banner-edit/:id",
  BANNER_LIST: "/banner-list",
  ORDER_LIST: "/order-list",
  ORDER_DETAIL: "/order-detail/:id",
};
